const getDefaultState = () => {
  return {
    animalTypes: [
      {
        id: 1,
        isActive: false,
        disabled: false,
        type: 'meatPoultry',
        name: 'Broilers',
        imgSrc: require('@/assets/images/animals/meat-poultry.png'),
        imgSrcProact: require('@/assets/images/animals/broiler-blue.png'),
        tooltip: 'This selection can be used for all meat-producing poultry species (e.g. turkey, ducks, quails)'
      },
      {
        id: 2,
        isActive: false,
        disabled: false,
        type: 'eggPoultry',
        name: 'Laying Hens',
        imgSrc: require('@/assets/images/animals/egg-poultry.png'),
        imgSrcProact: require('@/assets/images/animals/layers-blue.png'),
        tooltip: 'This selection can be used for all egg-producing poultry species (e.g. ducks, quails, breeders)'
      },
      {
        id: 3,
        isActive: false,
        disabled: false,
        type: 'swine',
        name: 'Swine',
        imgSrc: require('@/assets/images/animals/swine.png'),
        imgSrcProact: require('@/assets/images/animals/swine-blue.png'),
        tooltip: null
      },
      {
        id: 4,
        isActive: false,
        disabled: false,
        type: 'aqua',
        name: 'Fish',
        imgSrc: require('@/assets/images/animals/aqua.png'),
        imgSrcProact: require('@/assets/images/animals/aqua-blue.png'),
        tooltip: null,
        items: [
          {
            id: 5,
            parent_id: 4,
            isActive: false,
            disabled: false,
            type: 'aqua',
            subtype: 'shrimp',
            name: 'Shrimp',
          },
          {
            id: 6,
            parent_id: 4,
            isActive: false,
            disabled: false,
            type: 'aqua',
            subtype: 'fish',
            name: 'Tilapia',
          },
          {
            id: 7,
            parent_id: 4,
            isActive: false,
            disabled: true,
            type: 'aqua',
            subtype: 'fish',
            name: 'Cold Water',
          },
          {
            id: 8,
            parent_id: 4,
            isActive: false,
            disabled: true,
            type: 'aqua',
            subtype: 'fish',
            name: 'Warm Water',
          }
        ]
      },
    ],
    animalType: ''
  }
}

export default {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setActiveAnimalType(state, payload) {
      state.animalTypes.forEach(el => {
        el.isActive = false
        // eslint-disable-next-line no-unused-expressions
        el.items?.forEach(item => {
          item.isActive = false
        })
      })

      const activeAnimalType = state.animalTypes.find(el => el.type === payload.type)
      if (activeAnimalType) {
        activeAnimalType.isActive = true
      }
      const activeAnimal = activeAnimalType.items?.find(item => item.id === payload.id)
      if (activeAnimal) {
        activeAnimal.isActive = true
      }
    },

    resetState(state) {
      Object.assign(state, getDefaultState())
    }
  },

  getters: {
    animalTypeById: (state) => (id) => {
      // Search in the top-level array
      let result = state.animalTypes.find(el => el.id === id);

      // If not found, search in the nested `items` array
      if (!result) {
        for (const animalType of state.animalTypes) {
          if (animalType.items && Array.isArray(animalType.items)) {
            result = animalType.items.find(item => item.id === id);
            if (result) break; // Stop searching once found
          }
        }
      }

      return result; // Return the found object or undefined
    },
    isActiveMeatPoultry(state, getters) {
      return getters.getActiveAnimalType.type === 'meatPoultry'
    },
    isActiveEggPoultry(state, getters) {
      return getters.getActiveAnimalType.type === 'eggPoultry'
    },
    isActiveSwine(state, getters) {
      return getters.getActiveAnimalType.type === 'swine'
    },
    isActiveAqua(state, getters) {
      return getters.getActiveAnimalType.type === 'aqua'
    },
    getActiveAnimalType(state) {
      const activeAnimalType = state.animalTypes.find(el => el.isActive);

      if (!activeAnimalType) {
        return;
      }

      if (activeAnimalType.type === 'aqua' && activeAnimalType.items) {
        const activeSubItem = activeAnimalType.items.find(item => item.isActive);
        if (activeSubItem) {
          return activeSubItem;
        }
      }

      return activeAnimalType;
    },
    getActiveRatioByAnimalType(state, getters) {
      const ratios = {
        meatPoultry: 'ratio_broilers',
        eggPoultry: 'ratio_layers',
        swine: 'ratio_swine',
        aqua: 'ratio_aqua',
      };
      return ratios[getters.getActiveAnimalType.type] || ''
    }
  },

  actions: {
    resetState({ commit }) {
      commit('resetState')
    },
  }
}
